module.exports = __webpack_public_path__ + "media/images/237-cc6480740d424df97fe2bb583f22f430.gif";